import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL, umsUrl } from '../../../../Containers/Config/index.js';
import { VALIDATE_TOKEN_V2, VALIDATE_TOKEN_V2_SUCCESS, VALIDATE_TOKEN_V2_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* validateTokenV2({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/client/validate-reset-link`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        // ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
        'X-Requested-By': 'one-admin',
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message);
      yield put({
        type: VALIDATE_TOKEN_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: VALIDATE_TOKEN_V2_ERROR,
        payload: response?.data,
      });
    }
  } catch (error) {
    yield put({ type: VALIDATE_TOKEN_V2_ERROR, payload: error });
  }
}

export function* watchValidateTokenV2() {
  yield takeEvery(VALIDATE_TOKEN_V2, validateTokenV2);
}

function* validateTokenV2Saga() {
  yield all([fork(watchValidateTokenV2)]);
}

export default validateTokenV2Saga;
